"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleView = exports.SquareView = exports.FixedSizeView = void 0;
var ViewWithStyle_1 = require("./ViewWithStyle");
/**
 * provide props width and/or height for a fixed-size box with hidden overflow
 */
exports.FixedSizeView = ViewWithStyle_1.ViewWithStyle(function (_a) {
    var width = _a.width, height = _a.height;
    return ({
        width: width,
        height: height,
        overflow: 'hidden'
    });
});
/**
 * provide prop size for a square ie. a fixed-size with width and height the same
 */
exports.SquareView = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return exports.FixedSizeView(__assign(__assign({}, props), { width: size, height: size }));
};
/**
 * provide prop size (diameter) for a circle ie. a square with 50% border radius
 */
exports.CircleView = ViewWithStyle_1.ViewWithStyle(function (_a) {
    var size = _a.size;
    return ({
        width: size,
        height: size,
        borderRadius: .5 * size,
        overflow: 'hidden'
    });
});
//# sourceMappingURL=Size.js.map